/** Villes d'implantation (onglet Développement) : France + capitales voisines. */
import villesData from '../data/dgs/villes.json';
import typesData from '../data/dgs/types_magasin.json';

export const VILLES = villesData.villes;
export const SEUIL_INTERNATIONAL = villesData.deblocage_international_villes_fr;
export const VILLES_FRANCE = VILLES.filter(v => !v.international);
export const VILLES_INTL = VILLES.filter(v => v.international);
export const VILLE_PRINCIPAL_DEFAUT = 'lyon';
export const NB_TYPES_MAGASIN = typesData.types.filter(t => t.actif !== false).length;

/* Anciennes villes retirées (v1) → rattachement à la capitale du même pays. */
const MIGRATION_VILLES = { geneve: 'berne', barcelone: 'madrid', milan: 'rome' };

export const getVille = (id) => VILLES.find(v => v.id === (MIGRATION_VILLES[id] || id)) || null;

export const villeDuMagasin = (mag, principal = false) => {
  const brut = mag?.villeId || (principal ? VILLE_PRINCIPAL_DEFAUT : null);
  return brut ? (MIGRATION_VILLES[brut] || brut) : null;
};

export const nbMagasins = (retail) => (retail?.magasin ? 1 : 0) + (retail?.magasins || []).length;

/** Tous les magasins groupés par ville : { villeId: [{ magasin, principal }] }. */
export const magasinsParVille = (retail) => {
  const parVille = {};
  const ajouter = (m, principal) => {
    const v = villeDuMagasin(m, principal);
    if (!v) return;
    if (!parVille[v]) parVille[v] = [];
    parVille[v].push({ magasin: m, principal });
  };
  if (retail?.magasin) ajouter(retail.magasin, true);
  (retail?.magasins || []).forEach(m => ajouter(m, false));
  return parVille;
};

/** Types de magasin déjà présents dans une ville (max 1 de chaque). */
export const typesVille = (retail, villeId) =>
  [...new Set((magasinsParVille(retail)[villeId] || []).map(x => x.magasin.typeId).filter(Boolean))];

/* ── Statuts par ville (incitation au développement) ── */
export const STATUTS_VILLE = {
  presence: { label: 'Présence', couleur: '#94A3B8' },
  etabli: { label: 'Établi', couleur: '#38BDF8' },
  fort: { label: 'Fort', couleur: '#A78BFA' },
  domination: { label: 'Domination', couleur: '#FBBF24' },
};

export const statutVille = (nbTypes) => {
  if (nbTypes >= NB_TYPES_MAGASIN) return 'domination';
  if (nbTypes >= 3) return 'fort';
  if (nbTypes === 2) return 'etabli';
  return 'presence';
};

/** Bonus de trafic local selon la variété de formats dans la ville. */
export const bonusDominationPct = (nbTypes) => (nbTypes >= NB_TYPES_MAGASIN ? 5 : 0);

/* ── Bonus réseau global (notoriété) ── */
export const PALIERS_COUVERTURE = [
  { villes: 3, traficPct: 2 },
  { villes: 6, traficPct: 4 },
  { villes: 10, traficPct: 6 },
];
export const BONUS_CAPITALE_PCT = 1;

export const villesFranceDistinctes = (retail) =>
  Object.keys(magasinsParVille(retail)).filter(v => VILLES_FRANCE.some(x => x.id === v)).length;

export const internationalDebloque = (retail) => villesFranceDistinctes(retail) >= SEUIL_INTERNATIONAL;

/** Notoriété réseau : paliers de couverture + bonus par capitale étrangère.
 *  30/06 — les villes couvertes par un FRANCHISÉ comptent dans la couverture
 *  (notoriété) mais jamais dans la Domination (formats en propre uniquement). */
export const bonusReseauGeo = (retail) => {
  const parVille = magasinsParVille(retail);
  const villesSet = new Set(Object.keys(parVille));
  (retail?.franchise?.franchises || []).forEach(f => { if (f.villeId) villesSet.add(f.villeId); });
  const villesIds = [...villesSet];
  const nbVilles = villesIds.length;
  const nbCapitales = villesIds.filter(v => VILLES_INTL.some(x => x.id === v)).length;
  const palier = [...PALIERS_COUVERTURE].reverse().find(p => nbVilles >= p.villes) || null;
  const couverturePct = palier?.traficPct || 0;
  const capitalesPct = nbCapitales * BONUS_CAPITALE_PCT;
  const prochainPalier = PALIERS_COUVERTURE.find(p => nbVilles < p.villes) || null;
  return { nbVilles, nbCapitales, couverturePct, capitalesPct, totalPct: couverturePct + capitalesPct, prochainPalier };
};
